import { useState } from 'react';
import './Loader.scss';


function Loader() {
    return (
        <div className='load-window'>
            <div className="whirly-loader"></div>
        </div>
    );

}

export default Loader;
